import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';
import vocabIconWhiteBg from '../../assets/brand/VocabAI_icon_white_background.jpg';
import content from '../../translations/content.json';
import './Header.css';

const Header = () => {
  const { header } = content;
  const isNavigationEnabled = false;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/90 backdrop-blur-md">
      <div className="container mx-auto flex h-16 items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img
            src={vocabIconWhiteBg}
            alt="Vocab Icon"
            className="h-8 w-auto object-contain rounded-md"
          />
          <div className="flex flex-col items-center">
            <span className="font-extrabold text-2xl tracking-tight text-gray-900 flex items-center">
              Vocab<span className="text-[#FF6B00]">.AI</span>
            </span>
            <p className="text-[8px] text-slate-600 font-semibold -mt-1">
              — Understand. Communicate. Automate. <span className="text-[#E11D48]">—</span>
            </p>
          </div>
        </Link>
        <nav className="hidden md:flex items-center space-x-6">
          <ul className="flex items-center space-x-6">
            {header.nav.map((item) => (
              <li key={item.key}>
                {isNavigationEnabled ? (
                  <Link
                    to={`/${item.key}`}
                    className="flex items-center text-sm font-medium text-slate-700 hover:text-slate-900"
                  >
                    {item.label}
                    <ChevronDown className="ml-1 h-4 w-4" />
                  </Link>
                ) : (
                  <span className="flex items-center text-sm font-medium text-slate-500 cursor-not-allowed">
                    {item.label}
                    <ChevronDown className="ml-1 h-4 w-4" />
                  </span>
                )}
              </li>
            ))}
          </ul>
        </nav>
        <div className="hidden md:flex items-center space-x-4">
          <Link
            to="/book-demo"
            className="px-4 py-2 text-sm font-medium text-[#5E17EB] border border-[#5E17EB] rounded-md"
          >
            {header.cta.bookDemo}
          </Link>
          <Link
            to="/contact"
            className="px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-[#5E17EB] via-[#EC4899] to-[#FF6B00] rounded-md"
          >
            {header.cta.contactUs}
          </Link>
        </div>
        <button className="md:hidden" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu-drawer">
          <ul className="flex flex-col items-center space-y-6 py-8">
            {header.nav.map((item) => (
              <li key={item.key}>
                <span className="text-lg font-medium text-slate-500 cursor-not-allowed">
                  {item.label}
                </span>
              </li>
            ))}
            <li>
              <Link
                to="/book-demo"
                className="px-6 py-3 text-lg font-medium text-[#5E17EB] border border-[#5E17EB] rounded-md"
                onClick={toggleMobileMenu}
              >
                {header.cta.bookDemo}
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="px-6 py-3 text-lg font-medium text-white bg-gradient-to-r from-[#5E17EB] via-[#EC4899] to-[#FF6B00] rounded-md"
                onClick={toggleMobileMenu}
              >
                {header.cta.contactUs}
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
